import { Component, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-quote",
    styleUrl: "quote.scss",
    shadow: false
})
export class Quote {
    private baseClass = "ux-quote";

    /** The quote text to display  */
    @Prop() readonly quote: string = "";
    /** The source to display  */
    @Prop() readonly source: string = "";
    /** The image to display  */
    @Prop() readonly image: string = "";

    render() {
        return (
            <Host class={this.baseClass}>
                <div class={`${this.baseClass}__container`}>
                    {this.image && <img src={this.image} class={`${this.baseClass}__container-image`} />}
                    <div class={`${this.baseClass}__container-text ux-u-text-bold`}>{this.quote}</div>
                </div>
                <div
                    class={{
                        [`${this.baseClass}__source-container`]: true,
                        [`ux-col-11`]: true,
                        [`${this.baseClass}__source-container--image`]: this.image.length > 0
                    }}
                >
                    {this.source}
                </div>
            </Host>
        );
    }
}
